import { useEffect, useState } from 'react'
import { pageSizeOptions } from '../../../utils/constants'
import { allocation } from '../modals'
import { useBeds } from './useBeds'
import { getWards } from '../../lms/utils'
import { bedManagementDashboard } from '../../Radiology/Constants/constants'
import { ColDef } from 'ag-grid-community'
import { Box, useTheme } from '@mui/material'
import useCustomStyles from '../../../utils/hooks/CustomStylesHook'
import { radiologyColor } from '../../Radiology/Utils/RadiologyColors'
import MedAgDataGrid from '../../../components/MedAgDataGrid'
import { getBedDashboardByLocation } from '../../../services/IPDService'
import { toast } from 'react-toastify'
const styles = () => ({
  centerHeader: {
    color: radiologyColor?.white,
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
})
const BedManagementDashboard = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [wards, setWards] = useState([])
  const [locationName, setLocationName] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const locations = useBeds()
  const filtered = getWards(wards, locationName)
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(100)
  const [totalCount, setTotalCount] = useState(0)
  useEffect(() => {
    setPage(0)
    setPageSize(100)
  }, [locationName])
  const getBedDashboardApiCall = async () => {
    const response = await getBedDashboardByLocation(
      pageSize,
      page,
      locationName
    )
    if (response?.success) {
      if (response?.data?.ward_details?.length > 0) {
        const processedData = response?.data?.ward_details?.map((ward: any) => {
          const bedsCountByStatus = ward?.room_details?.reduce(
            (accumulator: any, room: any) => {
              room?.beds?.forEach((bed: any) => {
                accumulator[bed?.status] = (accumulator[bed?.status] || 0) + 1
              })
              return accumulator
            },
            {}
          )

          const totalBeds = ward?.room_details?.reduce(
            (accumulator: any, room: any) => {
              accumulator += room?.beds?.length
              return accumulator
            },
            0
          )

          return {
            wardName: ward?.ward_name,
            sequenceNumber: ward?.sequence_number ?? '-',
            location: ward?.location_id,
            floorNumber: ward?.floor_number,
            bedCategoryId:
              ward?.room_details?.length > 0
                ? ward?.room_details?.[0]?.beds?.[0]?.bed_category_id
                : null,
            bedsCountByStatus: bedsCountByStatus,
            totalBeds: totalBeds,
          }
        })
        setWards(processedData)
        setLoading(false)
        setTotalCount(response?.data?.ward_details_aggregate?.aggregate?.count)
      } else {
        setLoading(false)
        setWards([])
        setTotalCount(0)
      }
      toast.success(response.message)
    } else {
      setLoading(false)
      setWards([])
      setTotalCount(0)
      toast.error(response.message)
    }
  }
  useEffect(() => {
    getBedDashboardApiCall()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationName, page, pageSize])
  const columnDefs: ColDef[] = [
    {
      headerName: 'Seq No.',
      field: 'seqno',
      minWidth: 80,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.sequenceNumber ?? '-',
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Ward Name',
      field: 'wardName',
      minWidth: 250,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Operating Unit',
      field: 'location',
      minWidth: 100,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Floor',
      field: 'floorNumber',
      minWidth: 150,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.floorNumber ?? '-',
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Bed Category',
      field: 'bedCategory',
      minWidth: 130,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) => {
        const d = params?.data
        return d?.bedCategoryId === allocation.criticalNumber
          ? allocation.critical
          : d?.bedCategoryId === allocation.nonCriticalNumber
          ? allocation.nonCritical
          : '-'
      },
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Total',
      field: 'totalBeds',
      minWidth: 80,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Occupied',
      field: 'Occupied',
      minWidth: 80,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) =>
        params?.data?.bedsCountByStatus?.OCCUPIED ?? allocation.zeroNumber,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Available',
      field: 'available',
      minWidth: 80,
      sortable: false,
      filter: false,
      headerClass: classes?.centerHeader,
      cellRenderer: (params: any) =>
        params?.data?.bedsCountByStatus?.AVAILABE ?? allocation.zeroNumber,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
  ]

  return (
    <>
      <div className='bed-dashboard-container'>
        <div className='lms-filters bed-dashboard-main-content'>
          <div className='membershipText mt3 ml10'>
            {bedManagementDashboard}
          </div>
          <div>
            <select
              className='category-filter'
              name='location'
              value={locationName}
              onChange={(e) => setLocationName(e.target.value)}
            >
              <option value=''>{allocation?.selectLocation}</option>
              {locations?.map((op: any, i: number) => (
                <option key={i} value={op}>
                  {op}
                </option>
              ))}
            </select>
          </div>
        </div>
        <Box height={'96%'} width={'100%'}>
          <MedAgDataGrid
            tableHeight={'100%'}
            rowData={loading ? [] : filtered}
            columnDefs={columnDefs}
            pagination={true}
            pageSizeOptions={pageSizeOptions}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            totalRows={totalCount}
            exportIcon={false}
            searchField={false}
            headerHeight={30}
            localSearch={false}
            enableCellTextSelection={true}
            loading={loading}
          />
        </Box>
      </div>
    </>
  )
}
export default BedManagementDashboard
